import type { ReactNode } from "react";
import GridIcon from "../icons/GridIcon";
import ListIcon from "../icons/ListIcon";
import CheckIcon from "../icons/CheckIcon";
import styles from "./CatalogToolbar.module.css";

export type SortOption = "name" | "updated" | "created" | "official";
export type ViewMode = "grid" | "list";

const SORT_OPTIONS: { value: SortOption; label: string }[] = [
  { value: "name", label: "Name" },
  { value: "updated", label: "Recently Updated" },
  { value: "created", label: "Newest First" },
  { value: "official", label: "Official CAI first" },
];

interface CatalogToolbarProps {
  sortBy: SortOption;
  onSortChange: (sort: SortOption) => void;
  viewMode: ViewMode;
  onViewChange: (view: ViewMode) => void;
  officialOnly: boolean;
  onOfficialToggle: () => void;
  children?: ReactNode;
}

export default function CatalogToolbar({ sortBy, onSortChange, viewMode, onViewChange, officialOnly, onOfficialToggle, children }: CatalogToolbarProps) {
  return (
    <div className={styles.toolbar}>
      <div className={styles.left}>
        {children}
        <div className={styles.officialRow}>
          <span className={styles.officialLabel}>Official:</span>
          <button
            type="button"
            className={`${styles.officialToggle} ${officialOnly ? styles.officialToggleActive : ""}`}
            onClick={onOfficialToggle}
            aria-pressed={officialOnly}
            title="Show only Official CAI plug-ins and skills"
          >
            <span className={styles.officialToggleCheck} aria-hidden="true"><CheckIcon /></span>
            Official CAI only
          </button>
        </div>
      </div>
      <div className={styles.right}>
        <label className={styles.sortLabel} htmlFor="catalog-sort">Sort:</label>
        <select
          id="catalog-sort"
          className={styles.sortSelect}
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value as SortOption)}
        >
          {SORT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>

        <div className={styles.viewToggle} role="group" aria-label="View mode">
          <button
            className={`${styles.viewButton} ${viewMode === "grid" ? styles.active : ""}`}
            onClick={() => onViewChange("grid")}
            aria-label="Grid view"
            aria-pressed={viewMode === "grid"}
            type="button"
          >
            <GridIcon />
          </button>
          <button
            className={`${styles.viewButton} ${viewMode === "list" ? styles.active : ""}`}
            onClick={() => onViewChange("list")}
            aria-label="List view"
            aria-pressed={viewMode === "list"}
            type="button"
          >
            <ListIcon />
          </button>
        </div>
      </div>
    </div>
  );
}
